import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_dormitoryroom,
  add_dormitoryroom,
  update_dormitoryroom,
  delete_dormitoryroom,
  get_dormitoryroom_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  dormitoryroom: [],
  dormitoryroomlist: [],
  school_id: "",
  dormitory_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description: "",
    dormitory: "",
  },
};

// Async Thunks for API Calls
export const fetchdormitoryroomlist = createAsyncThunk(
  "dormitoryroom/fetchdormitoryroomlist",
  async ({ school_id, dormitory_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_dormitoryroom_list(school_id,dormitory_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchdormitoryroom = createAsyncThunk(
  "dormitoryroom/fetchdormitoryroom",
  async (
    { page, page_size, school_id,dormitory_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_dormitoryroom(
        page,
        page_size,
        school_id,
        dormitory_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createdormitoryroom = createAsyncThunk(
  "dormitoryroom/createdormitoryroom",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_dormitoryroom(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatedormitoryroom = createAsyncThunk(
  "dormitoryroom/updatedormitoryroom",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_dormitoryroom(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletedormitoryroom = createAsyncThunk(
  "dormitoryroom/deletedormitoryroom",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_dormitoryroom({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// dormitoryroom Slice
const dormitoryroomSlice = createSlice({
  name: "dormitoryrooms",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        name,
        description,
        dormitory
      } = action.payload;
      state.formData = {
        id,
        name,
        description,
        dormitory
      };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description: "",
        dormitory: "",
      
      };
    },
    setDormitoryroom(state, action) {
      state.dormitoryroom = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
    setDormitoryId(state, action) {
        state.dormitory_id = action.payload;
      },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchdormitoryroomlist.fulfilled, (state, action) => {
        state.dormitoryroomlist = action.payload.data;
      })
      // Fetch dormitoryroom
      .addCase(fetchdormitoryroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchdormitoryroom.fulfilled, (state, action) => {
        state.loading = false;
        state.dormitoryroom = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchdormitoryroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add dormitoryroom
      .addCase(createdormitoryroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createdormitoryroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.dormitoryroom = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createdormitoryroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update dormitoryroom
      .addCase(updatedormitoryroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatedormitoryroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatedormitoryroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete dormitoryroom
      .addCase(deletedormitoryroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletedormitoryroom.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletedormitoryroom.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setDormitoryRoom,
  setDormitoryId,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = dormitoryroomSlice.actions;
export default dormitoryroomSlice.reducer;
